<template>
  <div class="cask">
    <section class="py-4">
      <div class="container my-3">
        <div class="row justify-content-center">
          <div class="col-lg-8">

            <!-- 헤더 -->
            <div class="cask-header">
              <h2>1:1 문의내역</h2>
              <p class="ask-code" v-if="askCode">문의번호 {{ askCode }}</p>
            </div>

            <div class="cask-card">

              <!-- 상태 / 접수일 -->
              <div class="status-row">
                <span class="badge" :class="answerFlag === 'Y' ? 'badge-done' : 'badge-wait'">
                  {{ answerFlag === 'Y' ? '답변완료' : '답변대기' }}
                </span>
                <span class="ask-date" v-if="jDetail.insDate">{{ getDateFormat(jDetail.insDate) }} 접수</span>
              </div>

              <!-- 연결된 예약 (호텔 등 book_id가 있는 경우) -->
              <!-- <div class="linked-booking" v-if="jDetail.book_id">
                <i class="bi bi-link-45deg"></i>
                <span class="linked-label">관련 예약</span>
                <span class="linked-code" @click="goToBooking()">{{ jDetail.book_id }}</span>
                <i class="bi bi-chevron-right ms-auto"></i>
              </div> -->

              <div v-if="jDetail.book_id">
                <div v-if="jDetail.ctCode === 'H'">
                  <div class="linked-booking" v-if="jDetail.book_id" @click="goToBooking()">
                    <i class="bi bi-link-45deg"></i>
                    <span class="linked-label">관련 예약</span>
                    <span class="linked-code">{{ jDetail.book_id }}</span>
                    <i class="bi bi-chevron-right ms-auto"></i>
                  </div>
                </div>
                <div v-else-if="jDetail.ctCode != 'H' && pCode">
                  <div class="linked-booking" v-if="jDetail.book_id" @click="goToBooking()">
                    <i class="bi bi-link-45deg"></i>
                    <span class="linked-label">관련 예약</span>
                    <span class="linked-code">{{ jDetail.book_id }}</span>
                    <i class="bi bi-chevron-right ms-auto"></i>
                  </div>
                </div>
                <div  v-else-if="jDetail.ctCode != 'H' && !pCode">
                  <div class="linked-booking" v-if="jDetail.book_id">
                    <i class="bi bi-link-45deg"></i>
                    <span class="linked-label">관련 예약</span>
                    <span class="linked-code">{{ jDetail.book_id }}</span>
                    <i class="bi bi-chevron-right ms-auto"></i>
                  </div>
                </div>                
              </div>

              <hr class="divider">

              <!-- 문의유형 / 여행지역 -->
              <div class="row g-3 mb-3">
                <div class="col-md-6 field-group">
                  <label>문의유형</label>
                  <div class="field-value">{{ jDetail.cat || '-' }}</div>
                </div>
                <div class="col-md-6 field-group">
                  <label>여행지역</label>
                  <div class="field-value">{{ jDetail.nation || '-' }}</div>
                </div>
              </div>

              <!-- 제목 -->
              <div class="field-group mb-3">
                <label>제목</label>
                <div class="field-value">{{ jDetail.reqTitle }}</div>
              </div>

              <!-- 성명 / 이메일 / 연락처 -->
              <div class="row g-3 mb-3">
                <div class="col-md-4 field-group">
                  <label>성명</label>
                  <div class="field-value">{{ jDetail.reqPersonName }}</div>
                </div>
                <div class="col-md-4 field-group">
                  <label>이메일</label>
                  <div class="field-value">{{ jDetail.reqEmail }}</div>
                </div>
                <div class="col-md-4 field-group">
                  <label>연락처</label>
                  <div class="field-value">{{ jDetail.reqTel }}</div>
                </div>
              </div>

              <!-- 문의내용 -->
              <div class="field-group mb-4">
                <label>문의내용</label>
                <div class="field-value textarea-value">{{ jDetail.reqSpRemarks }}</div>
              </div>

              <!-- 답변 -->
              <div class="answer-box" :class="{ 'answer-empty': answerFlag !== 'Y' }">
                <div class="answer-header">
                  <span class="answer-title">
                    <i class="bi bi-chat-left-dots"></i> 문의답변
                  </span>
                  <span class="answer-date" v-if="answerFlag === 'Y'">
                    {{ getDateFormat(requestAnswer.insDate) }}
                  </span>
                </div>
                <div class="answer-content" v-if="answerFlag === 'Y'">
                  {{ requestAnswer.ansContent }}
                </div>
                <div class="answer-content answer-placeholder" v-else>
                  아직 답변이 등록되지 않았습니다. 확인 후 빠르게 답변드리겠습니다.
                </div>
              </div>

              <!-- 목록으로 -->
              <div class="mt-4 row justify-content-center">
                <button class="btn go col-6 col-lg-4" @click="goToList()">마이페이지</button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      askCode: '',
      jDetail: {},          // 상세페이지 정보
      requestAnswer: {},    // 답변내용
      answerFlag: 'N',      // 답변 존재 여부
      user: '',
      pCode: '',            // 일반예약용 상품코드
      
    };
  },
  created() {
    this.askCode  = this.$route.query.askCode;
    this.pCode    = this.$route.query.pCode || "";

    if (this.$store.state.user.handlerId != undefined) 
    {
      this.user = this.$store.state.user.handlerId;
    } 
    else if (this.$store.state.user.email != undefined) 
    {
      this.user = this.$store.state.user.email;
    } 
    else 
    {
      this.user = '';
    }

    this.getRequestDetail();
    this.getReqAnswer();
  },
  mounted() {
    window.scrollTo(0, 0);

    if (document.referrer == '') {
      this.$swal.fire('', '적절하지 않은 페이지 접근입니다.', 'error');
      location.replace('/');
    }
  },
  methods: {
    getDateFormat(date) {
      return this.$dateFormat(date);
    },
    async getRequestDetail() {
      //답변내용 상세
      let reqJoinDetail = await this.$api('/api/customerAskDetail', { param: [this.askCode] });
      this.jDetail = reqJoinDetail[0] || {};
    },
    // 문의답변
    async getReqAnswer() {
      let requestAnswer = await this.$api('/api/customerAskAnswer', { param: [this.askCode] });
      if (requestAnswer.length > 0) {
        this.requestAnswer = requestAnswer[0];
        this.answerFlag = 'Y';
      }
    },
    // 연결된 예약 상세로 이동 (ctCode별 분기)
    // ⚠️ 실제 라우트 경로/파라미터는 reserveInfoDetail_client.vue 라우트 정의에 맞춰 확인 필요
    goToBooking() {
      if (!this.jDetail.book_id) return;

      // 호텔예약
      if(this.jDetail.ctCode === 'H') 
      {
        this.$router.push({ path: '/reserveInfoDetail_client', query: {bookingNo: this.jDetail.book_id, cCode: this.jDetail.ctCode || 'H'} });
      }
      else if(this.jDetail.ctCode != 'H' && this.jDetail.ctCode != undefined)
      {
        this.$router.push({ path: '/reserveInfoDetail_client', query: {seqReq: this.jDetail.book_id, pCode: this.pCode, cCode: this.jDetail.ctCode || 'Y'} });
      }
    },
    goToList() {
      this.$router.push({ path: '/myPage' });
    },
  },
};
</script>

<style scoped>
.cask-header {
  text-align: center;
  margin-bottom: 1.75rem;
}
.cask-header h2 {
  font-weight: 700;
  font-size: 1.5rem;
  margin-bottom: .35rem;
}
.cask-header .ask-code {
  color: #999;
  font-size: .82rem;
  margin: 0;
}

.cask-card {
  background: #fff;
  border: 1px solid #ececec;
  border-radius: 14px;
  padding: 2rem 1.75rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, .03);
}

.status-row {
  display: flex;
  align-items: center;
  gap: .6rem;
  margin-bottom: 1rem;
}
.badge {
  display: inline-block;
  padding: .35rem .75rem;
  border-radius: 999px;
  font-size: .78rem;
  font-weight: 600;
}
.badge-done {
  background: #eaf7e4;
  color: #4f9c2b;
}
.badge-wait {
  background: #f1f1f1;
  color: #888;
}
.ask-date {
  font-size: .8rem;
  color: #aaa;
}

.linked-booking {
  display: flex;
  align-items: center;
  gap: .5rem;
  background: #f6faf3;
  border: 1px solid #dcefd2;
  border-radius: 10px;
  padding: .7rem 1rem;
  margin-bottom: 1.25rem;
  cursor: pointer;
  transition: background .15s ease;
}
.linked-booking:hover {
  background: #eef7e7;
}
.linked-booking i.bi-link-45deg {
  color: #6bab3e;
  font-size: 1.1rem;
}
.linked-label {
  font-size: .82rem;
  color: #666;
}
.linked-code {
  font-weight: 600;
  font-size: .88rem;
  color: #333;
}
.linked-booking i.bi-chevron-right {
  color: #b7d6a4;
}

.divider {
  border: none;
  border-top: 1px solid #f0f0f0;
  margin: 0 0 1.5rem;
}

.field-group label {
  display: block;
  font-size: .78rem;
  color: #999;
  font-weight: 600;
  margin-bottom: .3rem;
  letter-spacing: .01em;
}
.field-value {
  font-size: .92rem;
  color: #222;
  padding: .55rem .1rem;
  border-bottom: 1px solid #f0f0f0;
  min-height: 1.4rem;
  word-break: break-word;
}
.textarea-value {
  white-space: pre-line;
  line-height: 1.6;
  border-bottom: none;
  background: #fafafa;
  border-radius: 8px;
  padding: .9rem 1rem;
  min-height: 100px;
}

.answer-box {
  background: #f4f9f0;
  border: 1px solid #dcefd2;
  border-radius: 12px;
  padding: 1.25rem 1.4rem;
}
.answer-box.answer-empty {
  background: #fafafa;
  border-color: #ececec;
}
.answer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: .7rem;
}
.answer-title {
  font-weight: 700;
  font-size: .92rem;
  color: #4f9c2b;
}
.answer-empty .answer-title {
  color: #999;
}
.answer-date {
  font-size: .78rem;
  color: #999;
}
.answer-content {
  font-size: .9rem;
  line-height: 1.7;
  white-space: pre-line;
  color: #333;
}
.answer-placeholder {
  color: #aaa;
}

.cask .go {
  padding: 13px 0;
  background-color: #86cd53;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  transition: background .15s ease;
}
.cask .go:hover {
  background-color: #74b845;
}
</style>